import EventsSkeleton from 'modules/main/components/event-box-section/events-skeleton'
import { EventBoxSectionProps } from 'modules/main/components/event-box-section/types'
import RenderEvent from 'modules/main/components/render-event'
import { useMain } from 'modules/main/hooks/use-main'
import { MainEventType } from 'modules/main/types/main-interface'
import React, { useEffect, useState } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

export const EventBoxSection = React.forwardRef<
  HTMLDivElement,
  React.PropsWithChildren<EventBoxSectionProps>
>(function EventBoxSection({ filter }, ref) {
  const { t } = useLocoTranslation()
  const { events, revenue } = useMain(filter)
  const [eventsData, setEventsData] = useState<MainEventType[] | null>(null)

  useEffect(() => {
    if (events) {
      setEventsData(events.items)
    }
  }, [events])

  const hasEvents = eventsData?.length !== 0

  return (
    <div className="bg-background-secondary shadow-old-design relative min-h-[700px] w-full flex-none overflow-hidden rounded-lg lg:w-[326px]">
      <div className={`static flex w-full flex-col lg:absolute`}>
        <span className={'text-text-primary font-inter px-[25px] py-[23px] text-[20px] font-bold'}>
          {t('dashboard.main.event.title')}
        </span>
        <hr className={'color-[rgb(var(--background-tertiary))] opacity-10'} />
        {eventsData ? (
          hasEvents && (
            <>
              <div className={`flex flex-col gap-3 overflow-hidden px-[25px] pb-5`}>
                <ul className={'flex flex-col'}>
                  {eventsData.map((event, idx) => (
                    <li key={idx}>
                      <RenderEvent event={event} lastItem={idx === eventsData.length - 1} />
                    </li>
                  ))}
                </ul>
              </div>
            </>
          )
        ) : (
          <EventsSkeleton revenueLength={Object.keys(revenue || []).length} />
        )}
      </div>
      {hasEvents && (
        <div
          className={
            'absolute bottom-0 hidden h-[50px] w-[326px] rounded-lg bg-gradient-to-b from-[hsla(0,0%,100%,0)] to-[var(--color-background-secondary)] lg:block'
          }
        />
      )}
    </div>
  )
})
